import { ContentState } from 'draft-js';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { setOnboardingResume } from '~/components/onboarding/services';
import {
  getOnboardingResumeData,
  getSettingsPopupHash,
  isInternalUrl,
} from './utilLinks.parse';

type LinkProps = {
  contentState: ContentState;
  entityKey: string;
  children: React.ReactNode;
  decoratedText: string;
};

export const Link = ({ contentState, entityKey, decoratedText }: LinkProps) => {
  const { url } = contentState.getEntity(entityKey).getData() as {
    url?: string;
  };
  const navigate = useNavigate();

  const settingsHash = getSettingsPopupHash(url);

  if (settingsHash) {
    return (
      <a
        className='text-future-blue underline'
        href={settingsHash}
        onClick={(event) => {
          event.preventDefault();
          navigate(settingsHash);
        }}
      >
        {decoratedText}
      </a>
    );
  }

  // Handle onboarding resume links
  const onboardingResumeData = getOnboardingResumeData(url);

  if (onboardingResumeData) {
    return (
      <a
        className='text-future-blue underline'
        href='/onboarding/chat'
        onClick={(event) => {
          event.preventDefault();
          // Set resume state in localStorage so onboarding picks it up
          setOnboardingResume(onboardingResumeData);
          // Navigate to onboarding
          navigate('/onboarding/chat');
        }}
      >
        {decoratedText}
      </a>
    );
  }

  const isInternal = isInternalUrl(url);

  if (isInternal && url) {
    return (
      <a
        className='text-future-blue underline'
        href={url}
        onClick={(event) => {
          event.preventDefault();
          navigate(url);
        }}
      >
        {decoratedText}
      </a>
    );
  }

  return (
    <a
      className='text-future-blue underline'
      href={url}
      target='_blank'
      rel='noreferrer'
    >
      {decoratedText}
    </a>
  );
};

export const PastedLink = (props: { decoratedText: string }) => {
  const url = props.decoratedText;
  const navigate = useNavigate();

  const settingsHash = getSettingsPopupHash(url);

  if (settingsHash) {
    return (
      <a
        className='text-future-blue underline'
        href={settingsHash}
        onClick={(event) => {
          event.preventDefault();
          navigate(settingsHash);
        }}
      >
        {url}
      </a>
    );
  }

  // Handle onboarding resume links
  const onboardingResumeData = getOnboardingResumeData(url);

  if (onboardingResumeData) {
    return (
      <a
        className='text-future-blue underline'
        href='/onboarding/chat'
        onClick={(event) => {
          event.preventDefault();
          setOnboardingResume(onboardingResumeData);
          navigate('/onboarding/chat');
        }}
      >
        {url}
      </a>
    );
  }

  const isInternal = isInternalUrl(url);

  if (isInternal) {
    return (
      <a
        className='text-future-blue underline'
        href={url}
        onClick={(event) => {
          event.preventDefault();
          navigate(url);
        }}
      >
        {url}
      </a>
    );
  }

  return (
    <a
      className='text-future-blue underline'
      href={url}
      target='_blank'
      rel='noreferrer'
    >
      {url}
    </a>
  );
};
